import { render, staticRenderFns } from "./DocumentItemCardSales.vue?vue&type=template&id=08f39986&scoped=true"
import script from "./DocumentItemCardSales.vue?vue&type=script&lang=js"
export * from "./DocumentItemCardSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f39986",
  null
  
)

export default component.exports